module.exports = __webpack_public_path__ + "img/TPA_Logo.c830a87c.png";